/* BeautiEdit scratch card pop-up — used by sections/be-scratch-card.liquid */
(() => {
  if (customElements.get('be-scratch-card')) return;

  const STORE_KEY = 'be_scratch_v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } };
  const write = (v) => { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {} };

  class BeScratchCard extends HTMLElement {
    connectedCallback() {
      this.designMode = this.dataset.designMode === 'true';
      this.prizes = JSON.parse(document.getElementById(this.id.replace('be-scratch-', 'be-scratch-prizes-')).textContent || '[]');
      // Only codes that are live right now (the page itself may have been cached before a code ended)
      const now = Date.now();
      this.prizes = this.prizes.filter((p) => p.code &&
        (!p.starts_at || Date.parse(p.starts_at) <= now) &&
        (!p.ends_at || Date.parse(p.ends_at) > now));
      if (!this.prizes.length) return;

      const saved = read();
      const forceShow = /[?&]scratch=1/.test(location.search);
      if (!this.designMode && !forceShow && saved) {
        const days = Number(this.dataset.resurfaceDays || 0);
        const age = (Date.now() - (saved.t || 0)) / 864e5;
        if (saved.claimed || !days || age < days) return;
      }

      this.bind();
      if (this.designMode || forceShow) { this.open(); return; }
      this.arm();
    }

    arm() {
      const delay = Number(this.dataset.delay || 0) * 1000;
      const scrollPct = Number(this.dataset.scroll || 0);
      let fired = false;
      const fire = () => { if (fired) return; fired = true; window.removeEventListener('scroll', onScroll); this.open(); };
      const onScroll = () => {
        const pct = (window.scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight)) * 100;
        if (pct >= scrollPct) fire();
      };
      setTimeout(fire, delay);
      if (scrollPct > 0) window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 10) fire(); });
    }

    bind() {
      this.qsa('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      this.qs('[data-reveal]').addEventListener('click', () => this.reveal());
      this.qs('[data-form]').addEventListener('submit', (e) => this.claim(e));
      this.qs('[data-copy]').addEventListener('click', () => this.copy());
    }

    qs(s) { return this.querySelector(s); }
    qsa(s) { return this.querySelectorAll(s); }

    pick() {
      const total = this.prizes.reduce((n, p) => n + Math.max(0, Number(p.weight) || 0), 0) || 1;
      let r = Math.random() * total;
      for (const p of this.prizes) { r -= Math.max(0, Number(p.weight) || 0); if (r <= 0) return p; }
      return this.prizes[0];
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.prize = this.pick();
      this.qsa('[data-prize-label]').forEach((el) => (el.textContent = this.prize.label));
      this.qsa('[data-prize-detail]').forEach((el) => (el.textContent = this.prize.detail));
      this.hidden = false;
      this.lastFocus = document.activeElement;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('be-sc-open');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.paintFoil();
        this.qs('.be-sc__dialog').focus({ preventScroll: true });
      });
      if (!this.designMode) write({ t: Date.now(), claimed: false });
      this.startTimer();
      this.track('scratch_popup_view');
    }

    close() {
      this.classList.remove('is-open');
      clearInterval(this.timerId);
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('be-sc-open');
      setTimeout(() => { this.hidden = true; }, 400);
      if (this.lastFocus) this.lastFocus.focus?.({ preventScroll: true });
      this.track('scratch_popup_close', { stage: this.stage || 'scratch' });
    }

    startTimer() {
      const el = this.qs('[data-timer-display]');
      let left = Number(this.dataset.timer || 0);
      if (!el || !left) return;
      const box = el.parentElement;
      const tick = () => {
        const m = Math.floor(left / 60), s = String(left % 60).padStart(2, '0');
        el.textContent = `${m}:${s}`;
        box.classList.toggle('is-low', left <= 10);
        if (left <= 0) { clearInterval(this.timerId); if (!this.revealed) this.close(); return; }
        left -= 1;
      };
      tick();
      this.timerId = setInterval(tick, 1000);
    }

    paintFoil() {
      const canvas = this.qs('[data-foil]');
      const card = this.qs('[data-card]');
      const rect = { width: card.offsetWidth, height: card.offsetHeight }; // unaffected by the open animation's scale
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = rect.width * dpr; canvas.height = rect.height * dpr;
      const ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      const w = rect.width, h = rect.height;
      const css = getComputedStyle(this);
      const c = (v) => css.getPropertyValue(v).trim();

      const g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, c('--be-foil-a')); g.addColorStop(.35, c('--be-foil-b'));
      g.addColorStop(.6, c('--be-foil-c')); g.addColorStop(1, c('--be-foil-d'));
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);

      // brushed-foil texture
      for (let i = 0; i < 2600; i++) {
        ctx.fillStyle = `rgba(255,255,255,${Math.random() * .12})`;
        ctx.fillRect(Math.random() * w, Math.random() * h, Math.random() * 2, Math.random() * 2);
      }
      ctx.globalAlpha = .18; ctx.strokeStyle = '#fff'; ctx.lineWidth = 18; ctx.lineCap = 'round';
      for (let i = 0; i < 4; i++) { ctx.beginPath(); ctx.moveTo(w * (.28 + i * .12), h * .32); ctx.lineTo(w * (.2 + i * .12), h * .72); ctx.stroke(); }
      ctx.globalAlpha = 1;

      ctx.fillStyle = 'rgba(255,255,255,.88)';
      ctx.font = `700 ${Math.round(w / 11)}px ${getComputedStyle(document.body).fontFamily}`;
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.letterSpacing = '2px';
      ctx.fillText('SCRATCH HERE', w / 2, h / 2);

      this.ctx = ctx; this.w = w; this.h = h;
      ctx.globalCompositeOperation = 'destination-out';

      let drawing = false, last = null, moves = 0;
      const pt = (e) => { const r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) * (w / r.width), y: (e.clientY - r.top) * (h / r.height) }; };
      const scratch = (p) => {
        ctx.lineWidth = Math.max(34, w / 9); ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath(); ctx.moveTo((last || p).x, (last || p).y); ctx.lineTo(p.x, p.y); ctx.stroke();
        last = p;
        if (++moves % 12 === 0) this.checkCleared();
      };
      canvas.addEventListener('pointerdown', (e) => {
        drawing = true; last = null; canvas.setPointerCapture(e.pointerId); scratch(pt(e));
        if (!this.started) { this.started = true; this.track('scratch_popup_start'); }
      });
      canvas.addEventListener('pointermove', (e) => { if (drawing) scratch(pt(e)); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((t) => canvas.addEventListener(t, () => { drawing = false; last = null; this.checkCleared(); }));
    }

    checkCleared() {
      if (this.revealed) return;
      const { width, height } = this.ctx.canvas;
      const data = this.ctx.getImageData(0, 0, width, height).data;
      let clear = 0, n = 0;
      for (let i = 3; i < data.length; i += 4 * 24) { n++; if (data[i] === 0) clear++; }
      if (clear / n > 0.45) this.reveal();
    }

    reveal() {
      if (this.revealed) return;
      this.revealed = true;
      clearInterval(this.timerId);
      const timer = this.qs('.be-sc__timer'); if (timer) timer.hidden = true;
      this.qs('[data-foil]').classList.add('is-cleared');
      this.qs('[data-card]').classList.add('is-won');
      try { navigator.vibrate && navigator.vibrate([18, 40, 18]); } catch (e) {}
      this.track('scratch_popup_reveal', { prize: this.prize.label });
      setTimeout(() => this.goTo('claim'), 1300);
    }

    goTo(stage) {
      this.stage = stage;
      this.qsa('[data-stage]').forEach((el) => (el.hidden = el.dataset.stage !== stage));
      const focusEl = this.qs(`[data-stage="${stage}"] input, [data-stage="${stage}"] [data-copy]`);
      // On phones, don't auto-focus the email field: it would throw the keyboard up over the prize
      const touch = window.matchMedia('(pointer: coarse)').matches;
      if (focusEl && !(touch && focusEl.matches('input'))) focusEl.focus({ preventScroll: true });
      this.qs('.be-sc__dialog').scrollTop = 0;
    }

    async claim(e) {
      e.preventDefault();
      const form = e.currentTarget;
      const email = form.email.value.trim();
      const err = this.qs('[data-error]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.hidden = false; form.email.focus(); return; }
      err.hidden = true;
      const btn = form.querySelector('button'); btn.disabled = true;

      await this.subscribe(email).catch(() => {});
      if (this.prize.code && this.dataset.autoApply === 'true') {
        await fetch(`/discount/${encodeURIComponent(this.prize.code)}`, { credentials: 'same-origin' }).catch(() => {});
        this.qs('[data-applied-note]').hidden = false;
      }
      this.qs('[data-code]').textContent = this.prize.code || '';
      this.qs('[data-copy]').hidden = !this.prize.code;
      if (!this.designMode) write({ t: Date.now(), claimed: true });
      this.track('scratch_popup_claim', { prize: this.prize.label });
      this.goTo('code');
    }

    subscribe(email) {
      const company = this.dataset.klaviyoCompany, list = this.dataset.klaviyoList;
      if (!company || !list || this.designMode) return Promise.resolve();
      return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${company}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Scratch card pop-up',
              profile: { data: { type: 'profile', attributes: { email, properties: { scratch_card_prize: this.prize.label, scratch_card_code: this.prize.code } } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      });
    }

    async copy() {
      const code = this.qs('[data-code]').textContent;
      const label = this.qs('[data-copy-label]');
      try { await navigator.clipboard.writeText(code); label.textContent = 'Copied ✓'; } catch (e) { label.textContent = code; }
    }

    track(event, props = {}) {
      try { window.dataLayer && window.dataLayer.push({ event, ...props }); } catch (e) {}
      try { window.klaviyo && window.klaviyo.push(['track', event, props]); } catch (e) {}
    }
  }

  customElements.define('be-scratch-card', BeScratchCard);
})();
